import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Stack, Typography } from "@mui/material";

import { getCompanyProfilePath, ISOStringToRelativeTime } from "utils";

interface Props {
  bookedQuote: CondensedQuote | undefined;
}

export function ShipperView(props: Props) {
  const { bookedQuote } = props;

  if (!bookedQuote?.created_by || !bookedQuote?.created_by_company) {
    return null;
  }

  const carrierName = `${bookedQuote.created_by.first_name} ${bookedQuote.created_by.last_name}`;
  const carrierEmail = bookedQuote.created_by.email;
  const carrierCompany = bookedQuote.created_by_company.name;
  const lastLogin = bookedQuote.opposing_party_last_login;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Stack direction="column">
        <AccountCircleIcon fontSize="large" color="primary" />
      </Stack>

      <Stack direction="column">
        <Typography variant="h6">{carrierName}</Typography>
        {carrierEmail && (
          <Typography variant="body1">{carrierEmail}</Typography>
        )}
        {carrierCompany && (
          <Typography
            component="a"
            href={getCompanyProfilePath(bookedQuote.created_by_company.id)}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: "underline",
              color: "primary.main",
              cursor: "pointer",
              "&:hover": { color: "primary.dark" },
            }}
          >
            {carrierCompany}
          </Typography>
        )}
        {lastLogin && (
          <Typography variant="caption" color="text.secondary">
            {`Last active ${ISOStringToRelativeTime(lastLogin)}`}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
